import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Title from './Title';
import Instructions from './Instructions';
import TextBox from '../form/TextBox';
import SubmitButton from './SubmitButton';
import BackToSignInContainer from './BackToSignInContainer';
import { required, validEmail } from '../form/validators';

export const ForgotYourPassword = ({
  instructions,
  handleSubmit,
  errorMessage,
}) => (
  <article>
    <div className="box">
      <div className="pa3 cf">
        <form onSubmit={handleSubmit} >
          <Title text="Forgot your password?" />
          <Instructions {...instructions} />
          <Field
            name="email"
            label="Enter your email"
            component={TextBox}
            validate={[required, validEmail]}
            type="text"
          />
          <div id="errorMessage" className="red mb3 lh-title">
            { errorMessage }
          </div>
          <SubmitButton />
          <BackToSignInContainer />
        </form>
      </div>
    </div>
  </article>
);

ForgotYourPassword.propTypes = {
  instructions: PropTypes.shape({ text: PropTypes.string.isRequired }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

function ForgotYourPasswordForm({
  instructions,
  handleSubmit,
  errorMessage,
}) {
  return (
    <ForgotYourPassword
      instructions={instructions}
      handleSubmit={handleSubmit}
      errorMessage={errorMessage}
    />);
}

ForgotYourPasswordForm.propTypes = {
  instructions: PropTypes.shape({ text: PropTypes.string.isRequired }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

export default reduxForm({ form: 'reset-password' })(ForgotYourPasswordForm);
